import { z } from "zod"

import { DeliveryDateReference } from "@/graphql/codegen/graphql"

export const deliveryPackagingSchema = z.object({
  preferredDeliveryDateReference: z.nativeEnum(DeliveryDateReference).nullable(),
  packagingInstructions: z.string(),
  insureSmallParcel: z.boolean(),
})
